<style>
    .content{
        color:tan;
    }
    .content:visited{
    color:black;
    }

</style>
<div class="bg1 content"><a class="hoveref" href="https://calc.do-not-click-me.tk">calculator</a> <br> <a class="hoveref" href="https://covid.do-not-click-me.tk">covid previewer</a></div>
